import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { superRefinePhoneNumber } from "@/lib/helpers/phone-number-validation";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const loginSchema = z
  .object({
    phoneNumber: z.string().min(1, "Phone number is required"),
  })
  .superRefine(async (arg, ctx) => {
    await superRefinePhoneNumber({
      phoneNumber: arg.phoneNumber,
      ctx,
    });
  });

export type LoginFormData = z.input<typeof loginSchema>;

export interface LoginFormReturn extends UseFormReturn<LoginFormData> {
  defaultValues: LoginFormData;
}

const initialFormValues = { phoneNumber: "+65" };

export const useLoginForm = (): LoginFormReturn => ({
  defaultValues: initialFormValues,
  ...useForm<LoginFormData>({
    mode: "onChange",
    defaultValues: initialFormValues,
    resolver: zodResolver(loginSchema),
  }),
});
